<template>
  <div class="vx-row jrb" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-01' && isOpenPreview && isShowComment)" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-17/M007-17_jrb-01.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-02' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-17/M007-17_jrb-02.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-03' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-17/M007-17_jrb-03.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-04' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-17/M007-17_jrb-04.jpg" width="100%" />
      </vx-card>
    </div>
    </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <vx-card class=" preview-edit-screen">
        <table style="border: 1px solid #c9cbdc; border-radius: 6px" class="w-full" :id="`${arrayCommentId[0]}`"
               v-if="jrb == 'jrb-01' || jrb == 'jrb-02' || jrb == 'jrb-03' || jrb == 'jrb-04'">
          <tr>
            <td colspan="12" class="part-parent-name" style="padding-top: 10px; padding-left: 10px; padding-bottom: 10px; border-bottom: 1px solid #c9cbdc;">
              <span>Ⅳ　付属書類</span>
            </td>
          </tr>
          <tr>
            <td style="padding-top: 10px; padding-left: 46px">
              <div class="flex mb-3">
                <AttachmentTemplate @onselect="onSelectKyotakujo" :kubun="keiyakuKubun" style="padding-right: 25px"/>
                <vs-button @click="popupActiveClearAllWakaregyoshajoho = true">クリア</vs-button>
              </div>
            </td>
          </tr>
          <draggable v-model="fuzokushoruiGroup" handle=".handle">
            <table class="w-full" v-for="(element, index) in fuzokushoruiGroup" :key="`note-${index}`">
              <td style="padding-bottom: 10px;width: 100rem;">
                <div class="flex item-center">
                  <vs-checkbox style="padding-left: 20px; width: 10px;" v-model="element.fuzokushoruisentaku"></vs-checkbox>
                  <span style="padding-top: 10px;padding-left: 30px; padding-right: 25px; width:25px"> {{ index + 1 }}. </span>
                  <div style="margin-right: 20px;" class="handle pt-3 cursor-default w-19">
                    <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                      <DragBlackIcon />
                    </vx-tooltip>
                  </div>
                  <div class="w-2/5">
                    <vs-input @blur="focusOut()" @focus="onFocus(`element.fuzokushoruina.${index}`)" style="padding-right: 15px" v-model="element.fuzokushoruina" maxlength="38"></vs-input>
                    <span class="tooltip-custom" :class="addPadding(`element.fuzokushoruina.${index}`)">{{showMaxlength(38, element.fuzokushoruina, `element.fuzokushoruina.${index}`)}}</span>
                  </div>
                </div>
              </td>
            </table>
          </draggable>
          <tr>
            <td style="border-top: 0px; border-left: 0px; padding-right: 50px; padding-bottom: 10px">
              <div class="flex justify-end py-1">
                <vs-button class="mr-4 btn-positive" :disabled="fuzokushoruiGroup.length >= 100" @click="addToFuzokushorui()">項目追加
                </vs-button>
                <vs-button style="margin-left: 15px" class="btn-positive" color="positive" type="filled" text-color="#7367F0"
                          @click="deleteTokinaiyo()">項目削除
                </vs-button>
              </div>
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- Footer -->
      <footer-button @cancel="popupActiveCancelForm = true" @save="popupActiveSaveForm = true"></footer-button>

      <!-- Popup Delete Tokinaiyo -->
      <vs-popup class="holamundo" title="削除" :active.sync="popupActiveDeleteTokinaiyo" :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          選択された項目を削除します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleDeleteTokinaiyo">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveDeleteTokinaiyo = false">いいえ</vs-button>
        </div>
      </vs-popup>

      <!-- Popup Clear All Wakaregyoshajoho -->
      <vs-popup class="holamundo" title="クリア" :active.sync="popupActiveClearAllWakaregyoshajoho" :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">入力内容を破棄しますが、よろしいですか？</p>
          <div class="flex justify-end">
            <vs-button class="mr-8 btn-positive btn-yes" @click="deleteFuzokushoruina">はい</vs-button>
            <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveClearAllWakaregyoshajoho = false">いいえ</vs-button>
          </div>
      </vs-popup>

      <!-- Popup Cancel -->
      <vs-popup class="holamundo" title="キャンセル" :active.sync="popupActiveCancelForm" :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          入力内容を破棄して元の画面へ移動します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleCancelForm">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false">いいえ</vs-button>
        </div>
      </vs-popup>

      <!-- Popup Save -->
      <vs-popup class="holamundo" title="保存" :active.sync="popupActiveSaveForm" :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          入力した内容を保存します。よろしいですか？
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSaveForm">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false">いいえ</vs-button>
        </div>
      </vs-popup>
    </div>
    <vx-card class="vx-col comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'">
        <Comment @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="jrb" :screenCode="screenCode='M007-17'"/>
      </vx-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { SAVE_JRB_M007_17, SAVE_EDIT_MODE, SAVE_KEIYAKU} from '@/store/modules/keiyaku/actions.js'
import AttachmentTemplate from './components/AttachmentTemplate.vue'
import FooterButton from './components/FooterButton.vue'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import Comment from './comment'
import highlighter from '../mixins/highlighter'
import { M007_17_jrbHighlight } from '../constant/highlight'
import draggable from 'vuedraggable'
import DragBlackIcon from '@/assets/images/icons/DragBlackIcon.vue'

export default {
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components:{
    AttachmentTemplate,
    FooterButton,
    LeftPreviewSlider,
    DragBlackIcon,
    draggable,
    Comment
  },
  data() {
    return {
      arrayCommentId: [],
      arrayHighlightId: [],
      isShowComment: true,
      isOpenPreview: true,
      onInit: true,
      jrb01Fields: {
        field1: '重要事項説明書補足資料',
        field2: '土地登記事項証明書　　　　　　　　部',
        field3: '公図（写）',
        field4: '隣地所有者一覧表',
        field5: '配管図表',
        field6: '測量図面'
      },
      jrb02Fields: {
        field1: '重要事項説明書補足資料',
        field2: '土地登記事項証明書　　　　　　　　部',
        field3: '建物登記事項証明書　　　　　　　　部',
        field4: '公図（写）',
        field5: '隣地所有者一覧表',
        field6: '配管図表',
        field7: '測量図面'
      },
      jrb03Fields: {
        field1: '重要事項説明書補足資料',
        field2: '区分建物登記事項証明書　　　　　　部',
        field3: '土地登記事項証明書　　　　　　　　部',
        field4: '公図（写）',
        field5: '管理規約（写）',
        field6: '重要事項に係る調査報告書'
      },
      fuzokushoruiGroup: [],
      popupActiveDeleteTokinaiyo: false,
      currentSelectDeleteTokinaiyoType: null,
      popupActiveCancelForm: false,
      popupActiveSaveForm: false,
      disableReflectSellerInfo2: false,
      popupSelectFuzokushorui: false,
      popupActiveClearAllWakaregyoshajoho: false,
      keiyakuKubun: null,
      shorui: null,
      allElemnts: 0,
      currentEle: 0,
      indexEle: 0,
      elementsNoData: 0,
      elementsWithData: 0,
      elementLast: 0
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    const jrb17Data = _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_17', null))
    if (jrb17Data) {
      this.onInit = false
      if (Array.isArray(jrb17Data.fuzokushorui)) {
        this.fuzokushoruiGroup = jrb17Data.fuzokushorui
      } else {
        this.setDefaultData()
      }
    } else {
      this.setDefaultData()
    }
    for(let index = 0; this.fuzokushoruiGroup.length < 24; index++) this.fuzokushoruiGroup.push({
      fuzokushoruina: '',
      fuzokushoruisentaku: false
    })
    
    const editMode = _.get(this.$store.getters.editMode, 'jrb07_17', false)
    if (editMode) {
      this.validateWarning()
    }
  },
  created () {
    const kubunData = _.get(this.$store.getters.pattern, 'bukkenSb', null)

    if (kubunData !== null) {
      this.keiyakuKubun = kubunData
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    jrb() {
      return _.get(this.$store.getters, 'pattern.jusetsu.jrb', null)
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  methods: {
    setDefaultData() {
      this.fuzokushoruiGroup = []
      if (this.jrb === 'jrb-01') {
        this.fuzokushoruiGroup = Object.values(this.jrb01Fields).map(ele => ({
          fuzokushoruina: ele,
          fuzokushoruisentaku: false
        }))
      } else if (this.jrb === 'jrb-02') {
        this.fuzokushoruiGroup = Object.values(this.jrb02Fields).map(ele => ({
          fuzokushoruina: ele,
          fuzokushoruisentaku: false
        }))
      } else if (this.jrb === 'jrb-03' || this.jrb === 'jrb-04') {
        this.fuzokushoruiGroup = Object.values(this.jrb03Fields).map(ele => ({
          fuzokushoruina: ele,
          fuzokushoruisentaku: false
        }))
      }
    },
    onSelectKyotakujo(data) {
      this.allElemnts = 0
      for(const ele of this.fuzokushoruiGroup) {
        this.allElemnts = this.allElemnts + 1
        this.shorui = ele.fuzokushoruina
      }
      this.elementsNoData = 0
      for(const ele of this.fuzokushoruiGroup) {
        if (ele.fuzokushoruina !== null && ele.fuzokushoruina === '') {
          this.elementsNoData = this.elementsNoData + 1
        }
      }
      this.elementsWithData = this.allElemnts - this.elementsNoData
      this.elementLast = 0
      this.currentEle = 0
      this.indexEle = 0
      for(const ele of this.fuzokushoruiGroup) {
        this.indexEle += 1
        if (ele.fuzokushoruina !== null && ele.fuzokushoruina !== '') {
          this.currentEle += 1
          if (this.currentEle === this.elementsWithData) {
            this.elementLast = this.indexEle
          }
        }
      }
      if (this.elementLast === this.allElemnts) {
        for(const element of data) {
          this.fuzokushoruiGroup.push(
            {
              fuzokushoruina: element.name,
              fuzokushoruisentaku: false
            }
          )
        }
      } else {
        for(const element of data) {
          if (this.fuzokushoruiGroup.length === this.elementLast) {
            this.fuzokushoruiGroup.push(
              {
                fuzokushoruina: element.name,
                fuzokushoruisentaku: false
              }
            )
          } else {
            this.fuzokushoruiGroup[this.elementLast].fuzokushoruina = element.name
            this.fuzokushoruiGroup[this.elementLast].fuzokushoruisentaku = false
            this.elementLast += 1
          } 
        }
      }
    },

    addToFuzokushorui() {
      this.fuzokushoruiGroup.push(
        {
          fuzokushoruisentaku: false,
          fuzokushoruina: ''
        }
      )
    },
    deleteTokinaiyo() {
      if (!this.fuzokushoruiGroup.filter(fuzokushorui => fuzokushorui.fuzokushoruisentaku === true).length) {
        this.$toasted.error('項目が選択されていません。')
        return
      }
      this.popupActiveDeleteTokinaiyo = true
    },
    deleteFuzokushoruina() {
      this.popupActiveClearAllWakaregyoshajoho = false
      this.setDefaultData()
    },
    handleDeleteTokinaiyo() {
      this.popupActiveDeleteTokinaiyo = false
      this.fuzokushoruiGroup = this.fuzokushoruiGroup.filter(e => !e.fuzokushoruisentaku)
    },
    handleCancelForm() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      if (this.onInit) {
        this.setDefaultData()
        const jrbData = {
          fuzokushorui: this.fuzokushoruiGroup
        }
        this.$store.dispatch(SAVE_JRB_M007_17, jrbData).then(() => {
          this.$nextTick(() => {
            this.$router.push({name: 'jusetsu-m006-01'})
          })
        })
      } else {
        setTimeout(() => {
          this.$router.push({name: 'jusetsu-m006-01'})
        }, 200)
      }
    },
    handleSaveForm() {
      const handle = () => {
        const jrbData = {
          fuzokushorui: this.fuzokushoruiGroup
        }
        this.$store.dispatch(SAVE_JRB_M007_17, jrbData).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'jrb07_17': true})
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            this.popupActiveSaveForm = false
            setTimeout(() => {
              this.$router.push({name: 'jusetsu-m006-01'})
            }, 200)
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          if(!ele.label_flg) {
            idElement.push(ele.id_element)
          }
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('jrb'))
      
    },
    handleGetCommentId() {
      let jrbPatternHighlight = []
      switch (this.jrb) {
      case 'jrb-01':
        jrbPatternHighlight = M007_17_jrbHighlight
        this.index = 1
        break
      case 'jrb-02':
        jrbPatternHighlight = M007_17_jrbHighlight
        this.index = 72
        break
      case 'jrb-03':
        jrbPatternHighlight = M007_17_jrbHighlight
        this.index = 83
        break
      case 'jrb-04':
        jrbPatternHighlight = M007_17_jrbHighlight
        this.index = 83
        break
      default:
        break
      }
      const jrbHighlight = jrbPatternHighlight.map(item => {
        if(item) {
          this.index = this.index + 1
          if(this.jrb === 'jrb-01') {
            item = `${this.jrb}-00-${this.index}`
          } else {
            item = `${this.jrb}-${this.index}`
          }
        }
        return item
      })
      this.arrayCommentId = jrbHighlight
      
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}
</script>

<style scoped>
  .jrb {
    font-weight: bold;
  }
  .tbl-title {
    width: 7%;
  }
  tr th.tbl-title:first-child {
    width: 11%;
  }
  .tbl-content {
    width: 25%;
  }

  .btn-expand {
    height: 85px;
    font-size: 18px;
    font-weight: 600;
    width: 160px !important;
    border-radius: 15px;
  }
  .btn-expand .btn-text {
    display: flex;
    flex-direction: column;
    margin-bottom: -10px;
  }

  #search_result_tbl .vs-table--thead th {
    background: #7367f0;
    color: #fff;
  }
  .btn-positive {
    border: 1px solid #7367F0;
  }
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;
}
.comment-frame {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;
}
.w-57 {
  width: 56%;
}
.w-65 {
  width: 65%;
}
</style>
